// src/app/auth/keycloak.ts
import Keycloak from 'keycloak-js';
import { config } from '../config'; // اگر مسیر config جای دیگه‌ست، همین import رو مطابق پروژه‌ات اصلاح کن

export const keycloak = new Keycloak({
  url: config.keycloak.url,
  realm: config.keycloak.realm,
  clientId: config.keycloak.clientId,
});
